const Logo = ({ className = 'h-8 w-auto', variant = 'full' }) => {
  if (variant === 'icon') {
    return (
      <svg
        className={className}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Unitradeinternational Icon"
      >
        {/* Globe orbit rings */}
        <circle
          cx="24"
          cy="24"
          r="20"
          stroke="url(#gradient1)"
          strokeWidth="1.5"
          opacity="0.3"
        />
        <ellipse
          cx="24"
          cy="24"
          rx="20"
          ry="12"
          stroke="url(#gradient1)"
          strokeWidth="1.5"
          opacity="0.3"
          transform="rotate(30 24 24)"
        />
        
        {/* Candlestick arrow upward */}
        <path
          d="M24 8 L24 40 M20 12 L24 8 L28 12"
          stroke="#00C2A8"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="18"
          y="18"
          width="12"
          height="10"
          fill="#FF8C42"
          rx="1"
        />
        
        <defs>
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#2B1B65" />
            <stop offset="100%" stopColor="#00C2A8" />
          </linearGradient>
        </defs>
      </svg>
    )
  }

  return (
    <svg
      className={className}
      viewBox="0 0 320 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Unitradeinternational Logo"
    >
      {/* Icon */}
      <g>
        <circle
          cx="24"
          cy="24"
          r="20"
          stroke="url(#gradient2)"
          strokeWidth="1.5"
          opacity="0.3"
        />
        <ellipse
          cx="24"
          cy="24"
          rx="20"
          ry="12"
          stroke="url(#gradient2)"
          strokeWidth="1.5"
          opacity="0.3"
          transform="rotate(30 24 24)"
        />
        <path
          d="M24 8 L24 40 M20 12 L24 8 L28 12"
          stroke="#00C2A8"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="18" y="18" width="12" height="10" fill="#FF8C42" rx="1" />
      </g>

      {/* Text */}
      <text
        x="54"
        y="30"
        fontFamily="Manrope, sans-serif"
        fontSize="18"
        fontWeight="700"
        fill="#ffffff"
      >
        Unitradeinternational
      </text>

      <defs>
        <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2B1B65" />
          <stop offset="100%" stopColor="#00C2A8" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Logo
